import { RecentlyUsedFont } from "../types/recentlyUsedFont";
import { getRecentlyUsedFonts, RECENTLY_USED_FONTS_KEY } from "./getRecentlyUsedFonts";

export function addToRecentlyUsedFonts(font: RecentlyUsedFont) {
    localStorage.setItem(
        RECENTLY_USED_FONTS_KEY,
        JSON.stringify([
            font,
            ...getRecentlyUsedFonts()
                .filter((_f) => _f.family !== font.family)
                .slice(0, 3),
        ]),
    );
}
